import { FormControl, Stack } from "@mui/material";
import {
  PrimaryNormalFormHelperText,
  PrimaryNormalInputLabel,
  PrimaryNormalInputs,
} from "assets/Mui/globalTheme";
import { useFormContext } from "react-hook-form";

export default function SecondCompanyFollowUps() {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={4} justifyContent={"space-between"}>
        <FormControl sx={{ width: "100%" }} variant="standard">
          <PrimaryNormalInputLabel
            shrink
            htmlFor="login-glassdoor-outlined"
            error={errors.glassdoors_url}
          >
            glassdoor
          </PrimaryNormalInputLabel>
          <PrimaryNormalInputs
            fullWidth
            placeholder="Enter your glassdoor"
            {...register("glassdoors_url", { required: false })}
            id="login-glassdoor-outlined"
            autoFocus
            label="glassdoor address"
            type={"text"}
            error={errors.glassdoors_url}
            variant="outlined"
          />
          <PrimaryNormalFormHelperText error={errors.glassdoors_url}>
            {errors?.glassdoors_url ? "Email is a required field" : ""}
          </PrimaryNormalFormHelperText>
        </FormControl>
        <FormControl sx={{ width: "100%" }} variant="standard">
          <PrimaryNormalInputLabel
            shrink
            htmlFor="login-ambitionbox-outlined"
            error={errors.ambition_box_url}
          >
            ambitionbox
          </PrimaryNormalInputLabel>
          <PrimaryNormalInputs
            fullWidth
            placeholder="Enter your ambitionbox"
            {...register("ambition_box_url", { required: false })}
            id="login-ambitionbox-outlined"
            autoFocus
            label="ambitionbox address"
            type={"text"}
            error={errors.ambition_box_url}
            variant="outlined"
          />
          <PrimaryNormalFormHelperText error={errors.ambition_box_url}>
            {errors?.ambition_box_url ? "Email is a required field" : ""}
          </PrimaryNormalFormHelperText>
        </FormControl>
        <FormControl sx={{ width: "100%" }} variant="standard">
          <PrimaryNormalInputLabel
            shrink
            htmlFor="login-comparably-outlined"
            error={errors.comparably_url}
          >
            comparably
          </PrimaryNormalInputLabel>
          <PrimaryNormalInputs
            fullWidth
            placeholder="Enter your comparably"
            {...register("comparably_url", { required: false })}
            id="login-comparably-outlined"
            autoFocus
            label="comparably address"
            type={"text"}
            error={errors.comparably_url}
            variant="outlined"
          />
          <PrimaryNormalFormHelperText error={errors.comparably_url}>
            {errors?.comparably_url ? "Email is a required field" : ""}
          </PrimaryNormalFormHelperText>
        </FormControl>
      </Stack>
      <Stack direction={"row"} spacing={4} justifyContent={"space-between"}>
        <FormControl sx={{ width: "100%" }} variant="standard">
          <PrimaryNormalInputLabel
            shrink
            htmlFor="login-CarrerBliss-outlined"
            error={errors.careerbliss_url}
          >
            CarrerBliss
          </PrimaryNormalInputLabel>
          <PrimaryNormalInputs
            fullWidth
            placeholder="Enter your CarrerBliss"
            {...register("careerbliss_url", { required: false })}
            id="login-CarrerBliss-outlined"
            autoFocus
            label="CarrerBliss address"
            type={"text"}
            error={errors.careerbliss_url}
            variant="outlined"
          />
          <PrimaryNormalFormHelperText error={errors.careerbliss_url}>
            {errors?.careerbliss_url ? "Email is a required field" : ""}
          </PrimaryNormalFormHelperText>
        </FormControl>
        <FormControl sx={{ width: "100%" }} variant="standard">
          <PrimaryNormalInputLabel
            shrink
            htmlFor="login-payscale-outlined"
            error={errors.payscale_url}
          >
            payscale
          </PrimaryNormalInputLabel>
          <PrimaryNormalInputs
            fullWidth
            placeholder="Enter your payscale"
            {...register("payscale_url", { required: false })}
            id="login-payscale-outlined"
            autoFocus
            label="payscale address"
            type={"text"}
            error={errors.payscale_url}
            variant="outlined"
          />
          <PrimaryNormalFormHelperText error={errors.payscale_url}>
            {errors?.payscale_url ? "Email is a required field" : ""}
          </PrimaryNormalFormHelperText>
        </FormControl>
        <FormControl sx={{ width: "100%" }} variant="standard">
          <PrimaryNormalInputLabel
            shrink
            htmlFor="login-google_reviews-outlined"
            error={errors.google_reviews}
          >
            Google Reviews
          </PrimaryNormalInputLabel>
          <PrimaryNormalInputs
            fullWidth
            placeholder="Enter your google_reviews"
            {...register("google_reviews", { required: false })}
            id="login-google_reviews-outlined"
            autoFocus
            label="google_reviews address"
            type={"text"}
            error={errors.google_reviews}
            variant="outlined"
          />
          <PrimaryNormalFormHelperText error={errors.google_reviews}>
            {errors?.google_reviews ? "Email is a required field" : ""}
          </PrimaryNormalFormHelperText>
        </FormControl>
      </Stack>
    </Stack>
  );
}
